export default {
  namespaced: true,
  state() {
    return {
      selectedProperties: [],
      variants: [],
      chosenVariants: null,
    };
  },
  getters: {
    selectedProperties: state => {
      return state.selectedProperties;
    },
    allProductVariants: state => {
      return state.variants;
    },
    chosenVariant: state => {
      return state.chosenVariants ? state.chosenVariants[0] : null;
    },
    chosenVariants: state => {
      return state.chosenVariants;
    },
  },
  actions: {
    setSelectedProperties: (context, variant) => {
      context.commit("setSelectedProperties", variant);
    },
    setProductVariants: (context, variants) => {
      context.commit("setProductVariants", variants);
    },
    emptySelectedProperties: context => {
      context.commit("emptySelectedProperties");
    },
    setChosenVariants: (context, variants) => {
      context.commit("setChosenVariants", variants);
    },
  },
  mutations: {
    setSelectedProperties: (state, property) => {
      const selectedProperties = state.selectedProperties;

      selectedProperties.forEach((stateProperty, index) => {
        if (stateProperty.key === property.key) {
          state.selectedProperties.splice(index, 1);
        }
      });

      state.selectedProperties.push(property);
    },
    setProductVariants: (state, variants) => {
      state.variants = variants;
    },
    emptySelectedProperties: state => {
      state.selectedProperties = [];
    },
    setChosenVariants: (state, variants) => {
      state.chosenVariants = variants;
    },
  },
};
